// Floating contact widget — the purple toggle opens/closes a stack of
// contact actions (WhatsApp, Call). Closes on outside click or Escape.
document.querySelectorAll('[data-contact-widget]').forEach(widget => {
    const toggle = widget.querySelector('[data-contact-toggle]');
    if (!toggle) return;

    const setOpen = (open) => {
        widget.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
    };

    toggle.addEventListener('click', (e) => {
        e.stopPropagation();
        setOpen(!widget.classList.contains('is-open'));
    });

    document.addEventListener('click', (e) => {
        if (widget.classList.contains('is-open') && !widget.contains(e.target)) {
            setOpen(false);
        }
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && widget.classList.contains('is-open')) {
            setOpen(false);
            toggle.focus();
        }
    });
});
